import * as React from 'react'
import { Button, Form, Input } from 'semantic-ui-react'
import { adminService } from '../../../../../../services'
import { toast } from 'react-toastify'
import { Checkbox } from '../../../../../components'

type EditUserProps = {
  user: IUser
}
type EditUserState = {
  isLoading: boolean,
  data: {
    userActive?: boolean,
    amountChange?: number,
    reason?: string,
    password?: string,
    totalDepChange?: number,
  }
  amount: string,
  totalDepChange: string,
}

export default class EditUser extends React.Component<EditUserProps, EditUserState> {
  state: EditUserState = {
    isLoading: false,
    data: {
      userActive: false,
      amountChange: 0,
      reason: '',
    },
    amount: '',
    totalDepChange: '',
  }

  componentWillReceiveProps() {
    const {user} = this.props
    this.setState({
      isLoading: false,
      data: {
        userActive: user.active,
      }
    })
  }

// Number(data.value.replace(/[\D\s\._\-]+/g, ''))
  onDataChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    const {name, value, checked} = event.target
    const {data} = this.state
    if (name === 'userActive') {
      data.userActive = checked
    } else {
      data[name] = value.replace(/[,]+/g, '')
    }
    this.setState({data})
  }

  onChangeAmount = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    let amount
    if (event.target.value.substr(0, 1) === '-') {
      let str = event.target.value.substr(0, 1)
      let money = event.target.value.substr(1, event.target.value.length)
      let amountMoney = str + Number(money.replace(/[\D\s\._\-]+/g, '')).toLocaleString('en-US')
      amount = amountMoney
    } else {
      amount = Number(event.target.value.replace(/[\D\s\._\-]+/g, '')).toLocaleString('en-US')
    }
    if (event.target.name === 'totalDepChange') {
      this.setState({
        totalDepChange: amount
      })
    } else {
      this.setState({
        amount: amount
      })
    }
  }

  onSubmit = () => {
    const {data} = this.state
    const username = this.props.user.username
    this.setState({
      isLoading: true
    })
    adminService.editUser({
      active: data.userActive,
      amountChange: data.amountChange,
      username: username,
      reason: data.reason,
      password: data.password,
      totalDepChange: data.totalDepChange,
    }).then(user => {
      this.setState({
        isLoading: false
      })
      toast.success('Chỉnh sửa user thành công!')
      setTimeout(function () {
        window.location.reload()
      },         2000)
    }).catch(error => {
      this.setState({
        isLoading: false
      })
      toast.error('Chỉnh sửa user không thành công!' + error.message)
    })

  }

  render() {
    const {user} = this.props
    const {isLoading, data, amount, totalDepChange} = this.state
    return (
      <div>
        <Form loading={isLoading}>
          <Form.Field control={Input} type={'text'} label={'Tên tài khoản'} value={user.username} readOnly={true}/>
          <Form.Input
            control={Input}
            type={'text'}
            label={'Thay đổi số tiền'}
            name={'amountChange'}
            onChange={(e: any) => {
              this.onDataChange(e)
              this.onChangeAmount(e)
            }}
            value={amount}
          />
          <Form.Input label={'Lý do đổi'} name={'reason'} onChange={this.onDataChange} value={data.reason}/>
          <Form.Input label={'Password'} name={'password'} onChange={this.onDataChange} value={data.password}/>
          <Form.Input
            control={Input}
            type={'text'}
            label={'Thay đổi tiền đổi thưởng'}
            name={'totalDepChange'}
            onChange={(e: any) => {
              this.onDataChange(e)
              this.onChangeAmount(e)
            }}
            value={totalDepChange}
          />
          <Checkbox
            name={'userActive'}
            text={'Active'}
            onChange={this.onDataChange}
            checked={!!data.userActive}
          />
          <Form.Field control={Button} onClick={this.onSubmit}>Lưu</Form.Field>
        </Form>
      </div>)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Admin/modules/User/EditUser.tsx